// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const CertificationsMarquee = registerClientReference(
    function() { throw new Error("Attempted to call CertificationsMarquee() from the server but CertificationsMarquee is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/CertificationsMarquee/CertificationsMarquee.tsx",
    "CertificationsMarquee",
);
export default registerClientReference(
    function() { throw new Error("Attempted to call the default export of [project]/src/components/CertificationsMarquee/CertificationsMarquee.tsx from the server, but it's on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/CertificationsMarquee/CertificationsMarquee.tsx",
    "default",
);
